export default {
	userLogin: {
		uNamePlaceholder: 'Account, email or mobile number',
		uNameRule: 'Account, email or mobile number',
		pWPlaceholder: 'Please Enter The Password',
		passWordRule: 'Numbers + English letters (including case), 6-20 digits',
		passWordRule1: 'Numbers + English letters (including case), 8-20 digits',
		codeRule: 'The verification code is 6 digits',
		forgetPwd: 'Forgot Password',
		confirm: 'OK',
		setPwd: 'Numbers + English letters (including case), 6-20 digits',
		setPwd1: 'Numbers + English letters (including case), 8-20 digits',
		pwd: 'Password',
		setAgainPwd: 'Confirm Password',
		confirmPwd: 'Password inconsistency',
		clickConfirm: 'Click for captcha',
		confirmSuccess: 'Verified', //
		again: 'Resend', //
		againPass: '{time}s', //
		move: 'Drag slider to verify', //
		loginInfo: 'I want to sign in/up for my phone number,and I agree to the ',
		loginAccInfo: 'Read and agree ',
		service: 'Service Agreement',
		and: ' and ',
		security: 'Privacy Policy',
		bindPhone: 'Bind phone', //
		bindInfo: 'Your enterprise wechat has not been bound to the phone, please bind after use', //
		bindInfo1: 'Your phone number has not been bound to wechat, please use it after binding',
		bind: 'bind', //
		otherWayLogin: 'Login by other means', //
		copyright: '©2023 Beijing Zhongke Wenge Technology Co., Ltd. All Rights Reserved', //
		icp: '京ICP备17022028号', //
		webNum: '网信算备110108009321501240027号', //
		webCode: 'Beijing public network security 11010802034536', //
		phoneInfo: 'Please enter the correct phone number', //
		noPermission: 'Sorry, you do not have login rights', //
		codeErr: 'Failed to obtain the verification code. Procedure', //
		codeContinue: 'Verification failed, please try again', //
		slidConfirm: 'Drag the slider to verify', //
		errMsg: 'Request failed', //
		checkInfo: 'Please check "The service agreement and privacy policy"', //
		loginFail: 'Login failed, please try again', //
		webErr: 'Network error', //
		codeInfo: 'Code', //
		bindFail: 'Binding failed, please try again', //
		ways: 'OR', //
		getCode: 'Get verification code',
		oladPassInfo: 'Please enter the old password',
		clear: 'Clear successfully',
	},
	loginWays: {
		phone: 'Phone',
		qChat: 'Enterprise wechat',
		password: 'Account',
		wechat: 'WeChat',
	},
	setting: {
		unbind: 'Not-Bind',
		unbind1: 'Not-Bind',
		unBindInfo: 'Unbind successfully',
		setPwd: 'Change Password',
		baseInfo: 'Account Info',
		userId: 'UID',
		phone: 'Mobile',
		user: 'Account',
		password: 'Password',
		email: 'E-Mail',
		qchat: 'WxWorkID',
		bind: 'Bind',
		time: 'Registration',
		codeBind: 'Scanning Binding',
		oldPwdPassword: 'Please Enter The Old Password',
		newPwd: 'Please Enter Your New Password',
		newAgainPwd: 'Please Enter Your New Password Again',
		forgetInfo:
			'To ensure the security of your account, please verify your identity.After the authentication is successful, proceed to the next step.',
		findPwd: 'Password retrieval',
		resetPwd: 'Reset Password', //
		finsh: 'complete', //
		copySuccess: 'Successful replication', //
		pwdSuccess: 'Password changed successfully', //
		bindSuccess: 'Binding successful', //
		accountSuccess: 'Account modified successfully', //
		eamilInput: 'Please enter the correct email address', //
		emailSuccess: 'Email successfully modified', //
		nameInput: 'The name cannot be empty', //
		nameSuccess: 'Name changed successfully', //
		confirmPwd: 'Confirm Password',
		adminSetPwd: 'Set Admin Password',
		adminPwd: 'Admin Password',
		singOut: 'Cancel Account',
		info1: 'This operation is irreversible',
		info2: 'The information will be deleted and cannot be recovered',
		info3: '· All conversations under your account',
		info4: '· Information about the agent you created',
		logout: 'Logout successful',
	},
	user: {
		nickName: 'Nickname', //
		userManage: 'Users',

		// userType:"User Types",
		userType: 'Types',
		// balckLists:'Block Status',
		balckLists: 'Status',
		role: 'Roles',
		// placeholdKeyW:"Search…",
		placeholdKeyW: 'Type keywords',
		add: 'New User',
		account: 'Account Number', //
		userName: 'username',
		wgRole: 'Internal Users',
		otherRole: 'External Users',
		time: 'valid priod',
		loinTime: 'register date',
		loginTime: 'last login time',
		wordTest: 'security',
		open: 'ON',
		close: 'OFF',
		operation: 'operations',
		edit: 'Edit',
		delete: 'Delete',
		logOut: 'LogOut',
		defriend: 'Block',
		relieve: 'relieve', //
		askLog: 'Conversations',
		resetPwd: 'Reset Password', //
		addUser: 'Add User',
		editUser: 'Edit User',
		accountPlaceHold: 'Please Enter Your Account Number', //
		accountInfo: "The account number cannot be a pure number and cannot contain {'@'}",
		require: 'Required',
		input: 'Please Enter',
		email: 'Email',
		user: 'User',
		abUser: 'Normal User',
		admin: 'Administrator',
		validTime: 'Valid Duration',
		vip: 'VIP',
		endTime: 'deadLine',
		vipTime: 'VIP DeadLine',
		remark: 'Remarks',
		cancel: 'Cancel',
		confirm: 'Confirm',
		yes: 'Yes',
		no: 'No',
		resetSuccess: 'Reset successfully', //
		warning: 'Confirm',
		confirmDelete: 'Are you sure you want to delete General',
		deleteMsg: 'Successfully deleted', //
		leaveMsg: 'Offline success', //
		operateMsg: 'Successful operation', //
		addMsg: 'Add successfully', //
		editMsg: 'Edit successfully', //
		edmitMsg: 'Commit failure', //
		third: 'Third-Party Account', //
		setNick: 'Change A Nickname', //
		setEmail: 'Modify Email', //
		setAccount: 'Modify Account', //
		pwd: 'Cipher', //
		loginReset: 'The device login is invalid', //
		loginInfo: 'Your current account login is invalid,{second}s will automatically enter the new account', //
		timeInfo: '{second}s enters automatically', //
		loginAgainInfo: 'Please Login Again', //
		loginAgain: 'Log back in', //
		setPwd: 'Set a password', //
		payFail: 'Failed',
		paySuccess: 'Success',
		serviceGift: 'Donate',
		paySuccessTip1: 'Last service balance',
		paySuccessTip2: ' The total balance after deduction is',
		paySuccessTip3: ' please learn about,',
		clearPwd: 'Clearing Admini Password',
		confirmClear: 'Sure to clear administrator password?',
		free: 'Free',
		vipSelect: 'VIP',
		placeVip: 'SubscriptionPlan',
		api: 'API Service',
		apiName: 'Get YAYI API documents (including Token of this account)',
		apiBtn: 'Acquire',
		apiInfo: 'It has been sent to email',
		msgInfo: 'Please enter a valid email address in the basic information',
		timeInfo2: 'Get ({t}s)',
	},

	personal: {
		dataReview: 'Overview',
		userId: 'UID',
		select: 'Select…',
		technology: 'Skill Invokes',
		useTotal: 'Details',
		unit: 'unit: times', //
		serviceTotal: 'Service Invokes',
		unitTimes: 'times',
		custom: 'Recent consumption', //
		customInfo: 'Prices', //
		info: 'Tips',
		tokenInfo: '1 token ≈ 1.25 characters', //
		equal: 'equal',
		customDetail: 'Consumptions', //
		unitYuan: 'unit: CNY', //
		unitToken: 'unit：tokens',
		yuan: 'CNY',
		difference: 'Balance(tokens)', //
		arrears: 'Arrears(tokens)',
		total: 'Total Recharge ', //
		give: 'Donate ', //
		CNY: ' CNY', //
		pay: 'Recharge', //
		payDetail: 'Details',
		paySituation: 'Rechargements',
		app: 'Apply', //
		accountPay: 'Recharge', //
		moneyInfo: '1. Please make sure your payment account has sufficient funds for trading.', //
		thirInfo: '2. When transaction error occurs, please go to the third-party payment platform to confirm.', //
		checkInfo: '3. After the recharge is completed, you can check transaction records in Recharges>Details, and view the balance in Profile>Overview', //
		canUse: 'Balance(CNY)', //
		payWay: 'Payment', //
		payTotal: 'Amount', //
		payConfiem: 'Pay', //
		payInfo: 'Confirming payment means agreement to the "Recharge Agreement" of this platform.', //
		payFinish: 'Completed payment', //
		zfbPay: 'AliPay', //
		wechatPay: 'WeChat', //
		realPay: 'out-of-pocket', //
		scanPay: 'Open Alipay and scan the QR code to complete the payment', //
		payService: 'Recharge Agreement', //
		zfb: 'AliPay', //
		wechat: 'WeChat', //
		servicesInfo: 'Please check "Confirm payment means you agree to the Platform" Recharge Agreement"', //
		payChoice: 'Please select the recharge amount', //
		paySuccess: 'You have successfully recharged, recharge amount and other details please check in ', //
		payCheck: '里查看', //
		userType: 'User Types',
		// payStatu:'Payment Status',
		payStatu: 'Status',
		// payWays:'Payment Method',
		payWays: 'Method',
		placeHold: 'Search by username or bill id',
		placeHold1: 'Please Enter The Order Number', //
		export: 'Export',
		number: 'order id',
		userName: 'username',
		money: 'amount(CNY)',
		giveMoney: 'donate(CNY)',
		time: 'recharge time',
		systeamGiven: 'Donate', //
		success: 'Successful', //
		fail: 'Fail', //
		categoryPlace: 'All Categories', //
		technologyPlace: 'All Skills', //
		useTime: 'invoke time', //
		category: 'category', //
		techno: 'skill', //
		serName: 'service', //
		userTimes: 'ninvoke times', //
		toekn: 'token amount', //
		price: 'unit price', //
		customInfos: 'Cost statement', //
		customTotal: 'consumption(CNY)', //
		totalTimes: 'Total Invokes',
		placehold2: 'Search by user phone number',
		noData: 'No record', //
		useUnit: 'unit: times',
		useToken: 'unit: token',
		skillList: 'Skill List',
		defineMoney: 'Custom Amount',
		readInfo: 'Please check "The service agreement and privacy policy"',
		editSuccess: 'Modified successfully',
		setSuccess: 'The password is changed successfully. You need to log in again',
		selectAgent: 'Please select an intelligent agent',
		addApplication: 'Add application',
		applyName: 'apply name',
		smartAgent: 'Smart Agent',
		appNodata: 'No agent',
		releaseDate: 'Release Date',
		pubSuccess: 'Copied publishing link',
		link: 'Link',
		isEnabled: 'Is Enabled',
		conversationRecord: 'Chat Record',
		chatRecord: 'Chat Record',
		rename: 'Rename',
		disableSmartAgentApp: 'Disable Smart Agent Application',
		disableDescription:
			'After disabling, the corresponding link for this application will become invalid, and other users will not be able to continue the conversation with the smart agent via the link.',
		selectSmartAgentToPublish: 'Select the Smart Agent to Publish',
		public: 'Public',
		shareToMe: 'Share to Me',
		my: 'My',
		publish: 'Publish',
		enabled: 'Enabled',
		disabled: 'Disabled',
		enterName: 'Enter Name',
		application: 'Application',
		conversation: 'Conversation',
		work: 'Work',
		enterApplicationName: 'Enter Application Name',
		selectVisitor: 'Select Visitor',
		visitor: 'Visitor',
		ipAddress: 'IP Address',
		visitorConversationCreateTime: 'Visitor Conversation Create Time',
		view: 'View',
		viewConversationRecord: 'View Conversation Record',
		workCreateTime: 'Work Create Time',
		generating: 'Generating',
		generationFailed: 'Generation Failed',
		generationCompleted: 'Generation Completed',
		status: 'Status',
		type: 'Type',
		longText: 'details',
		creditsCenter: 'Points Center',
		creditsRule: 'Research Points Rules',
		creditsDesc: 'Available / Total Earned',
		consume: 'Points Used: {total}',
		invite: 'Invite Friends to Earn Points',
		inviteDesc: 'For each new user you invite',
		credits: 'Points',
		inviteLink: 'Referral Link:',
		inviteUser: 'Total Invited',
		getCreDits: 'Points Earned',
		inviteRule: {
			title: 'Invitation Rules',
			content1: 'For each new user who successfully registers and completes identity verification, you will receive a reward',
			reward: 'Reward',
			rewardIssue: 'Reward Distribution',
			content2: 'Invitation rewards will be automatically credited to your account within 24 hours after the invited user completes registration.',
			notes: 'Important Notes',
			note1: '- Invited users must be new users registering on the platform for the first time.',
			note2: '- The platform reserves the right to revoke rewards for malicious registrations or fraudulent activities.',
			note3: '- The invitation link is for personal use only and must not be used for any illegal purposes.',
		},
		researchValue: {
			researchValueTitle: 'Research Points Rules',
			whatIsResearchValue: 'What are Research Points？',
			whatIsResearchValueDesc:
				"Research Points are the platform's core credit system, used to measure a user's research capabilities and activity level. Earn Research Points by completing various research tasks and academic activities to unlock more advanced features and privileges.",
			earnResearchValueTitle: 'Earning Research Points',
			earnByInvited: 'Being invited by a friend',
			earnByInviting: 'Invite Friends',
			perPerson: 'Person',
			consumeResearchValueTitle: 'Spending Research Points',
			generateReview: 'Generating a research summary',
			useFastMode: 'Using Turbo Mode',
			useResearchMode: 'Using Research Mode',
			times: 'Time',
			specialNoteTitle: 'Special Notes',
			specialNote1: 'Research Points are valid for one year. Please use them in a timely manner.',
			specialNote2: 'Fraudulently accumulating Research Points is prohibited. Violators will have their points balance cleared and their accounts will be suspended.',
			specialNote3: 'The platform reserves the right of final interpretation for the Research Points rules.',
		},
		creditsDetails: 'Points History',
		incomeRecord: 'Earned',
		outcomeRecord: 'Spent',
		copyTip: 'Invitation link copied to clipboard. Go ahead and share it with your friends~',
	},
	router: {
		creditsCenter: 'Points Center',
		personalCenter: 'Personal Center',
		accountOverview: 'Overview',
		personalPublic: 'Management',
		rechargeManagement: 'Recharge Management',
		accountRecharge: 'Account Recharge',
		rechargeDetails: 'Recharges',
		consumptionDetails: 'Consumption Details',
		callStatistics: 'Invokes',
		accountSettings: 'Profile',
		backendManagement: 'Backend Management',
		dataStatistics: 'Statistics',
		overview: 'Dashboard',
		userManagement: 'Users',
		applicationManagement: 'Consults',
		YAYIChat: 'Chat',
		YAYILit: 'Lit',
		skillApplicationManagement: 'Skill List',
		skillCategoryManagement: 'Category List',
		likeAndDislikeManagement: 'Feedback',
		QAndARecords: 'Conversations',
		YAYIFile: 'YAYIFile',
		knowledgeBaseManagement: 'KB Repos',
		login: 'Sign In',
		trialApplication: 'Trial Application',
		serviceAgreement: 'Service Agreements',
		privacyPolicy: 'Privacy Policy',
		advancedSetting: 'Advanced Setting',
	},
	manage: {
		totalUser: 'Total Users',
		individual: 'Personal',
		enterprise: 'Enterprise',
		totalCall: 'Total Invokes',
		errorCall: 'Failed Invokes',
		dataOverview: 'Overview',
		pleaseSelect: 'Select…',
		all: 'All',
		rechargeStatus: 'Rechargements',
		rechargeDetails: 'Recharges',
		currencyUnit: 'Unit: CNY',
		skillCallStatus: 'Skill Invokes',
		callStatistics: 'Invokes',
		timesUnit: 'Unit: times',
		serviceCallStatistics: 'Service Invokes',
		TotalAndCount: 'times',
		userTypes: 'User Types',
		// paymentStatus: 'Pay Status',
		paymentStatus: 'Status',
		paymentStatusTitle: 'pay status',
		// PaymentMethods: 'Pay Channel',
		PaymentMethods: 'Channel',
		// userAndOrderPlaceholder: 'Search by username or bill id',
		userAndOrderPlaceholder: 'Type username or bill id',
		orderPlaceholder: 'Please Enter The Id',
		export: 'Export',
		orderNumber: 'id',
		userName: 'user name',
		rechargeAmount: 'amount',
		bonusAmount: 'donate',
		rechargeTime: 'bill time',
		paymentMethod: 'payment method',
		systemGift: 'Donate',
		wechat: 'WeChat',
		aliPay: 'AliPay',
		success: 'Success',
		failure: 'Failure',
		callDataPlaceholder: 'Search by user phone number',
		noRecord: 'No records found',
		skillList: 'Skill List',
		amountUnit: 'tokens cost',
		numberUnit: 'invoke times',
		userManagement: 'Users',
		blacklist: 'Block Status',
		role: 'Roles',
		// keywordPlaceholder: 'Search…',
		keywordPlaceholder: 'Type keywords',
		add: 'Add',
		newUser: 'New User',
		phoneNumber: 'phone number',
		staff: 'Internal Users',
		customer: 'External Users',
		validDuration: 'valid priod',
		registrationTime: 'register date',
		lastLogin: 'last sign in',
		sensitiveWordDetection: 'security',
		enable: 'ON',
		disable: 'OFF',
		operation: 'operations',
		edit: 'Edit',
		delete: 'Delete',
		block: 'Block',
		remove: 'Remove',
		QAndARecords: 'Conversations',
		addUser: 'New User',
		editUser: 'Edit User',
		phonePlaceholder: 'Your phone number',
		required: 'Required',
		placeholder: 'Please Enter',
		email: 'email',
		user: 'username',
		generalUser: 'Normal User',
		admin: 'Administrator',
		validDuration2: 'Valid Duration',
		remarks: 'Remarks',
		cancel: 'Cancel',
		confirm: 'Confirm',
		yes: 'Yes',
		no: 'No',
		blocked: 'Blocked',
		notBlocked: 'Not Blocked',
		phoneValidPlaceholder: 'Please Enter A Valid Phone Number',
		emailValidPlaceholder: 'Please Enter A Valid Email Address',
		confirmTitle: 'Confirm',
		sureDelete: 'Are you sure you want to delete',
		deletionSuccessful: 'Deletion successful',
		offlineSuccessful: 'Offline successful',
		operationSuccessful: 'Operation successful',
		additionSuccessful: 'Addition successful',
		editSuccessful: 'Edit successful',
		createSuccessful: 'Create successful',
		submissionFailed: 'Submission failed',
		applicationManagement: 'Consults',
		industry: 'Industry',
		industryTitle: 'industry',
		// approvalStatus: 'Audit Status',
		approvalStatus: 'Status',
		name: 'name',
		companyName: 'enterprise',
		businessScenario: 'scene',
		source: 'source',
		serviceObject: 'service type',
		internal: 'Internal',
		external: 'External',
		applicationTime: 'request time',
		status: 'status',
		toBeApproved: 'Pending',
		approved: 'Passed',
		rejected: 'Rejected',
		review: 'Audit',
		auditResult: 'Audit Result',
		approvalResult: 'Approval Result',
		invitationCode: 'invitation code',
		emailSent: 'Passed and emailed sent',
		emailSent2: 'Approved and email sent',
		reason: 'Reason',
		sending: 'Sending',
		submit: 'Submit',
		rejectReason: 'Reject Reason',
		optional: 'optional',
		reject: 'Reject',
		sendSuccessful: 'Send Successful',
		invalidEmail: 'Invalid Email',
		skillApplicationManagement: 'Skill List',
		roleQuery: 'Roles',
		category: 'Category',
		categoryTitle: 'category',
		skillID: 'id',
		skillName: 'name',
		recommendedSkill: 'template',
		example: 'example',
		permission1: 'Permission',
		permission: 'permission',
		public: 'Public',
		private: 'Private',
		creationTime: 'create time',
		creator: 'creator',
		enable2: 'Publish',
		disable2: 'Revoke',
		disableTheSkill: 'Are you sure?',
		newSkill: 'New Skill',
		addSkill: 'Add Skill',
		editSkill: 'Edit Skill',
		pleaseEnterTheSkillName: 'Please Enter The Skill Name',
		beta: 'beta version',
		pleaseSelectTheCategory: 'Please Select The Category',
		moreThanOneOption: 'You can check more than one option',
		skillIntroduction: 'summary',
		pleaseEnterTheTemplateContent: 'Please enter the template content',
		backgroundRole: 'role description',
		recommendedQuestions: 'suggestions',
		promptEmptyPlaceholder: 'Please enter prompt',
		variable: 'variables',
		variablePlaceholder: 'Please enter variable example value',
		noData: 'no data available',
		creativity: 'creativity',
		save: 'Save',
		saveAndPublish: 'Save and Publish',
		debug: 'Preview',
		promptPreview: 'Prompt Preview',
		promptPreviewTip: 'Enter a prompt in the left field for real-time preview',
		run: 'Run',
		result: 'Result',
		time: 'Time',
		takeToken: 'Cost Token',
		generateResult: 'Result generating...',
		variableName: 'name',
		type: 'type',
		string: 'String',
		publishSuccessful: 'Publish successful',
		takenDownSuccessful: 'Taken down successful',
		copySuccessful: 'Copy successful',
		deleteSkill: 'Confirm Delete',
		deleteSkillAlert: 'Deleted skills can NOT be recovered, please confirm you really want to delete it.',
		skillCategoryManagement: 'Category List',
		categoryID: 'id',
		categoryName: 'name',
		description: 'description',
		addCategory: 'Add Category',
		editCategory: 'Edit Category',
		PleaseEnterTheCategoryName: 'Please enter the category name',
		thumbsUpAndDownQA: 'Thumbs-up/down for Intelligent Q&A',
		thumbsUpAndDownType: 'Type',
		thumbsUpAndDownTypeTitle: 'type',
		// keywordOrPhone: 'Search by keyword or phone number',
		keywordOrPhone: 'Type keyword or phone number',
		thumbsUp: 'Thumbs-up',
		thumbsDown: 'Thumbs-down',
		category2: 'category',
		feedback: 'Feedback',
		feedbackTitle: 'feedback',
		QAndA: 'Q&A',
		applicationAndParameters: 'app&params',
		IPAddress: 'ip addr',
		userAgent: 'useragent',
		userPhoneNumber: 'phone number',
		feedbackUser: 'feeduser',
		toBeReviewed: 'Pending',
		approved2: 'Agree',
		disapproved: 'Disagree',
		application: 'Application',
		applicationParameters: 'Application Parameters',
		reasonsForDisagreement: 'Reasons for Disagreement',
		thumbsUpDownManagement: 'Thumbs-up/down management',
		likeAndDislikeManagement: 'Feedback',
		feedbackTime: 'Feedback Time',
		approvalResult2: 'Approval Result',
		IntelligentQAndALog: 'Intelligent Q&A Log',
		category3: 'Skill',
		category3Title: 'skill',
		sensitive: 'Sensitive',
		sensitiveTitle: 'sensitive',
		YaYiInputParameter: 'llm params',
		prompt: 'prompt',
		calledPlugin: 'plugin',
		pluginOutput: 'plugin output',
		notSensitive: 'No',
		sensitive2: 'Yes',
		time2: 'create time',
		category4: 'Category',
		target: 'Target',
		knowledgeBaseManagement: 'KB Repos',
		// keywordAndUser: 'Search by repo name or phone number',
		keywordAndUser: 'Type repo name or phone number',
		knowledgeBaseID: 'id',
		knowledgeBaseName: 'Name',
		knowledgeBaseNameTitle: 'name',
		publiclyAccessible: 'Full Public',
		internallyAccessible: 'Internal Public',
		numberOfFiles: 'files',
		wordCount: 'chars',
		expand: 'Upgrade',
		addKnowledgeBase: 'New Repo',
		editKnowledgeBase: 'Edit KB Repo',
		pleaseEnterTheKnowledgeBaseName: 'Please enter the knowledge base name',
		icon: 'Icon',
		description2: 'Description',
		brieflyDescribe: 'Please briefly describe this knowledge base.',
		deleteKnowledgeBase: 'Are you sure?',
		deleteKnowledgeBaseAlert: 'Deleted repos can NOT be recovered, please confirm you really want to delete it.',
		comingSoon: 'Coming soon',
		knowledgeBaseQAndA: 'Knowledge Base Q&A',
		likeAndDislikeType: 'Type',
		likeAndDislikeTypeTitle: 'type',
		knowledgeBaseQAndALogs: 'Knowledge Base Q&A Logs',
		searchResult: 'search result',
		searchParameter: 'search parameter',
		knowledgeBase: 'Knowledge Base',
		userPrivate: 'User Private',
		permissionType: 'permission',
		newRepo: 'New Repo',
		userAdd: 'New User',
		account: 'account number',
		tableuserName: 'user name',
		// userType:"user type",
		userType: 'Type',
		tabletime: 'valid priod',
		normalUser: 'Normal',
		deletedUser: 'Deleted',
		logoutUser: 'Unsubscribed',
		blockUser: 'Blocked',
		deleted: 'Deleted',
		haveDeleted: 'Deleted',
		haveLogOut: 'Cancelled',
		emaillInfo: 'Please enter the correct email format',
		aiDraw: 'AI painting',
		experience: 'Experience mode',
		longFile: 'Long document',
		graphicsSelection: 'Graphics Selection',
		backgroundColor: 'Background Color',
	},
	log: {
		manageLog: 'Audit',
	},
};
